import { render } from "./ContentItem.vue?vue&type=template&id=2686840c&scoped=true&ts=true"
import script from "./ContentItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContentItem.vue?vue&type=script&lang=ts&setup=true"

import "./ContentItem.vue?vue&type=style&index=0&id=2686840c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2686840c"],['__file',"src/pages/report/components/ContentItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2686840c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2686840c', __exports__)) {
    api.reload('2686840c', __exports__)
  }
  
  module.hot.accept("./ContentItem.vue?vue&type=template&id=2686840c&scoped=true&ts=true", () => {
    api.rerender('2686840c', render)
  })

}


export default __exports__